import PropTypes from 'prop-types'

// Copy that quotes the conversion rate reads it off the partner record rather
// than hardcoding it, so a rate change in the seeds flows through to the wording.
export const conversionRateValues = (partner) => ({
  mldPointRateFactor: partner?.mldPointRateFactor,
  externalPointRateFactor: partner?.externalPointRateFactor,
})

export const conversionRatePartnerShape = PropTypes.shape({
  mldPointRateFactor: PropTypes.number,
  externalPointRateFactor: PropTypes.number,
})
